// Components
import StandardRichTextToolContainer from '../../toolbar/selectionTools/richContentTools/StandardRichTextToolContainer';

// Constants
import { STYLE_COMMANDS } from '../../../components/editor/richText/richTextConstants';
import { COLLAPSE_ORDER, TOOL_HEIGHT } from './toolbarToolConfigConstants';

// Types
import { ToolbarItemConfig } from '../toolbarTypes';
import CenterTextRichTextToolContainer from '../../toolbar/selectionTools/richContentTools/CenterTextRichTextToolContainer';
import HyperlinkRichTextToolContainer from '../../toolbar/selectionTools/richContentTools/HyperlinkRichTextToolContainer';
import TextStyleRichTextToolContainer from '../../toolbar/selectionTools/richContentTools/textStylesTool/TextStyleRichTextToolContainer';
import AssignUserTool from '../../toolbar/selectionTools/assignmentTools/AssignUserTool';

const ASSIGNMENT: ToolbarItemConfig = {
    id: 'ASSIGNMENT',
    name: 'Assign',
    height: TOOL_HEIGHT.SQUARE,
    component: AssignUserTool,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
};

const TEXT_STYLES: ToolbarItemConfig = {
    id: 'TEXT_STYLE',
    name: 'Text style',
    height: TOOL_HEIGHT.SQUARE,
    component: TextStyleRichTextToolContainer,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        showBlockStyleTools: false,
    },
};

const TEXT_BLOCK_STYLES: ToolbarItemConfig = {
    id: 'TEXT_BLOCK_STYLES',
    name: 'Block styles',
    height: TOOL_HEIGHT.SQUARE,
    component: TextStyleRichTextToolContainer,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        showBlockStyleTools: true,
    },
};

const TEXT_BOLD: ToolbarItemConfig = {
    id: 'TEXT_BOLD',
    name: 'Bold',
    tooltipText: 'Bold',
    shortcut: ['command', 'b'],
    iconName: 'toolbar-bold',
    height: TOOL_HEIGHT.SQUARE,
    component: StandardRichTextToolContainer,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        styleCommand: STYLE_COMMANDS.BOLD,
    },
};

const TEXT_ITALIC: ToolbarItemConfig = {
    id: 'TEXT_ITALIC',
    name: 'Italic',
    tooltipText: 'Italic',
    // Adding a space to visually shift the 1 across slightly
    shortcut: ['command', ' ', ' ', 'i'],
    iconName: 'toolbar-italic',
    component: StandardRichTextToolContainer,
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        styleCommand: STYLE_COMMANDS.ITALIC,
    },
};

const TEXT_STRIKETHROUGH: ToolbarItemConfig = {
    id: 'TEXT_STRIKETHROUGH',
    name: 'Strikethrough',
    tooltipText: 'Strikethrough',
    shortcut: ['command', 'shift', 'X'],
    iconName: 'toolbar-strikethrough',
    component: StandardRichTextToolContainer,
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        styleCommand: STYLE_COMMANDS.STRIKETHROUGH,
    },
};

const TEXT_BULLET_LIST: ToolbarItemConfig = {
    id: 'TEXT_BULLET_LIST',
    name: 'Bullet',
    tooltipText: 'Bullet',
    shortcut: ['command', 'shift', 'u'],
    iconName: 'toolbar-list',
    component: StandardRichTextToolContainer,
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        styleCommand: STYLE_COMMANDS.LIST,
    },
};

const TEXT_ORDERED_LIST: ToolbarItemConfig = {
    id: 'TEXT_ORDERED_LIST',
    name: 'Numbered list',
    tooltipText: 'Numbered list',
    shortcut: ['command', 'shift', 'o'],
    iconName: 'toolbar-numlist',
    component: StandardRichTextToolContainer,
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        styleCommand: STYLE_COMMANDS.ORDERED_LIST,
    },
};

const TEXT_CENTERED: ToolbarItemConfig = {
    id: 'TEXT_CENTERED',
    name: 'Align center',
    tooltipText: 'Align center',
    // Adding a space to visually shift the 1 across slightly
    shortcut: ['command', ' ', ' ', '\\'],
    iconName: 'toolbar-center-text',
    component: CenterTextRichTextToolContainer,
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
};

const TEXT_HYPERLINK: ToolbarItemConfig = {
    id: 'TEXT_HYPERLINK',
    name: 'Hyperlink',
    tooltipText: 'Hyperlink',
    shortcut: ['command', 'k'],
    iconName: 'toolbar-hyperlink',
    component: HyperlinkRichTextToolContainer,
    height: TOOL_HEIGHT.SQUARE,
    collapseOrder: COLLAPSE_ORDER.DEFAULT,
    toolSettings: {
        styleCommand: STYLE_COMMANDS.HYPERLINK,
    },
};

export default {
    TEXT_STYLES,
    TEXT_BLOCK_STYLES,
    TEXT_BOLD,
    TEXT_ITALIC,
    TEXT_STRIKETHROUGH,
    TEXT_BULLET_LIST,
    TEXT_ORDERED_LIST,
    TEXT_CENTERED,
    TEXT_HYPERLINK,
    ASSIGNMENT,
} as const;
